var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#212543"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5C20 12.7188 19.0312 11.0938 17.5 10.1875C15.9375 9.28125 14.0312 9.28125 12.5 10.1875C10.9375 11.0938 10 12.7188 10 14.5C10 16.3125 10.9375 17.9375 12.5 18.8438C14.0312 19.75 15.9375 19.75 17.5 18.8438C19.0312 17.9375 20 16.3125 20 14.5ZM19.0312 19.625C17.9062 20.5 16.5 21 15 21C11.4062 21 8.5 18.0938 8.5 14.5C8.5 10.9375 11.4062 8 15 8C18.5625 8 21.5 10.9375 21.5 14.5C21.5 16.0312 20.9688 17.4375 20.0938 18.5625L24.2812 22.7188C24.5625 23.0312 24.5625 23.5 24.2812 23.7812C23.9688 24.0938 23.5 24.0938 23.2188 23.7812L19.0312 19.625Z",
    fill: "#F1F5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilled);
export default __webpack_public_path__ + "static/media/icon-filled.9ea0b37af48fb8c1e6625cc52c4d9ceb.svg";
export { ForwardRef as ReactComponent };